import type { OrgsState } from '@/features/org/state/orgs.slice';

/** Selector helpers. Pure — no Redux hooks here, callers wrap with useSelector. */

export const selectOrgs = (state: any): OrgsState['list'] => (state.orgs as OrgsState)?.list ?? [];

export const selectActiveSlug = (state: any): string | null =>
  (state.orgs as OrgsState)?.activeSlug ?? null;

export const selectActiveOrg = (state: any) => {
  const s = state.orgs as OrgsState | undefined;
  if (!s?.activeSlug) return null;
  return s.list.find((o) => o.slug === s.activeSlug) ?? null;
};

export const selectMyRole = (state: any): string | null => selectActiveOrg(state)?.myRole ?? null;

export const selectOrgsLoading = (state: any): boolean => !!(state.orgs as OrgsState)?.loading;
